import { People, Person, PersonAdd } from "@mui/icons-material";
import { Box, Card, styled, Button, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import React, { useState, useEffect } from "react";
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TableComponent from "../TableComponent";

const MainBox = styled(Box)(({ theme }) => ({
  padding: "25px 50px",
  borderRadius: "15px",
  display: "inline-block",
  border: "1px solid #888",
  cursor: "pointer",
  margin: "20px",
  textAlign: "center",
  [theme.breakpoints.down('md')]: {
    margin: "0",
    //   marginBottom:"20px"
  },
  "& svg": {
    fontSize: "75px",
  },
}));

const BoxFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down('md')]: {
    flexDirection: "column",
    gap: "10px"
  },

}))




const FirstPage = ({
  step,
  setStep,
  setCustomerDetails,
  handleChooseType,
  columns2,
  handleResume,
  handleDelete,
  customerDetails,
  setKeyLoading,
  keyLoading,
  deletingRow,
  setDeletingRow,
}) => {
  //const [rows1, setRows1] = useState([]);

  // useEffect(() => {
  //   const rows = localStorage.getItem("order-list");
  //   if (rows != null) {
  //     const parsedRows = JSON.parse(rows);

  //     parsedRows.sort((a, b) => b.timestamp - a.timestamp);

  //     const latest5Rows = parsedRows.slice(0, 5);

  //     setRows1(latest5Rows);
  //   }
  // }, []);

  // const rows = localStorage.getItem("order-list");
  // const parsedRows = JSON.parse(rows);
  // parsedRows.sort((a, b) => b.timestamp - a.timestamp);   
  // const latest5Rows = parsedRows.slice(0, 5);
  // const rows1 = latest5Rows;

  let rows1;

  if (localStorage.getItem("order-list")) {
    const rows = localStorage.getItem("order-list");
    const parsedRows = JSON.parse(rows);
    parsedRows.sort((a, b) => b.timestamp - a.timestamp);
    const latest5Rows = parsedRows.slice(0, 5);
    rows1 = latest5Rows;
  } else {
    rows1 = [];
  }

  // Now you can use the rows1 variable as needed



  //console.log("customerdet", customerDetails)
  // console.log("step", step);
  return (
    <>
      <Card>
        <Box p={4}>
          <Box mb={4} textAlign="center">
            <h2>ROF</h2>
          </Box>
          <BoxFlex>
            <MainBox onClick={() => handleChooseType("resume")}>
              <p>Resume Order</p>
              <People color={customerDetails.type === "resume" ? "primary" : "disabled"} />
            </MainBox>
            <div>
              or
            </div>
            <MainBox onClick={() => handleChooseType("existing")}>
              <p>Existing Customer</p>
              <Person color={customerDetails.type === "existing" ? "primary" : "disabled"} />
            </MainBox>
            <div>
              or
            </div>
            <MainBox onClick={() => setStep(1, customerDetails.type = "new")}>
              <p>New Customer</p>
              {/* <Box textAlign={"center"} pt={3}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setStep(1, customerDetails.type="new")}
            >
              + New Customer
            </Button>
          </Box> */}
              <PersonAdd
                
                color={customerDetails.type === "new" ? "primary" : "disabled"}
              />
            </MainBox>
          </BoxFlex>
        </Box>

      </Card>
      <br />

      <Card>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <Box mb={4} textAlign="left">
                <h2>Recent 5 Orders</h2>
              </Box>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <TableComponent
                columns={columns2}
                rows={rows1}
                handleResume={handleResume}
                handleDelete={handleDelete}
                setKeyLoading={setKeyLoading}
                keyLoading={keyLoading}
                deletingRow={deletingRow}
                setDeletingRow={setDeletingRow}
                rowsPerPage="5"

              />
            </Typography>
          </AccordionDetails>
        </Accordion>



      </Card>
    </>
  );
};

export default FirstPage;
